module.exports = __webpack_public_path__ + "static/philarmonie-5f6ee8d5c1afac833986f1e884993c20.svg";